const sizeOptions = {
  big: 'size-big',
  medium: 'size-medium',
  small: 'size-small',
  smallest: 'size-smallest'
};

export { sizeOptions };
//# sourceMappingURL=sizeOptions.js.map
